import { render, staticRenderFns } from "./chateau-rieussec.vue?vue&type=template&id=b92891ca&scoped=true"
import script from "./chateau-rieussec.vue?vue&type=script&lang=js"
export * from "./chateau-rieussec.vue?vue&type=script&lang=js"
import style0 from "./chateau-rieussec.vue?vue&type=style&index=0&id=b92891ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92891ca",
  null
  
)

export default component.exports